module.exports = __webpack_public_path__ + "static/media/personal_folder_home_icon.b582da4d.png";